/**
 * Lytics audience integration
 * @module
 */

var VENDOR = 'lytics';

var _ = require('optimizely-client-fn');
var PromiseEnv = require('core/lib/promise').Promise;

var Poll = require('core/utils/poll');
var WindowEnv = require('core/env/window');



/**
 * @returns {Object|undefined}
 */
function getLyticsData(): any|undefined {
  var lytics = WindowEnv.getGlobal('lio');
  if (lytics && lytics.segmentsCookie) {
    return {
      audiences: _.keys(lytics.segmentsCookie),
    };
  }
}

var pluginAudienceLytics: AudiencePluginConfig = {
  provider: {
    isAsync: true,

    getter: [
      function() {
        return function(getValue, setValue) {
          var initialLyticsData = getLyticsData();
          if (initialLyticsData) {
            // Synchronously populate the visitor profile to avoid FOUC on pages with synchronous Lytics snippets.
            setValue(initialLyticsData);
            return PromiseEnv.resolve(initialLyticsData);
          } else {
            // Asynchronously populate the visitor profile on pages with asynchronous Lytics snippets.
            return Poll.pollFor(getLyticsData);
          }
        };
      }
    ],
  },

  matcher: require('core/plugins/matchers/key_value'),

  vendor: VENDOR,
};

module.exports = function(PluginManager) {
  PluginManager.registerAudiencePlugin(pluginAudienceLytics);
};

if (__TEST__) {
  module.exports.plugin = pluginAudienceLytics;
  module.exports.getLyticsData = getLyticsData;
}
